import CustomersRoutes from './customers.routes';

const Customers = () => {
  return (
    <>
      <CustomersRoutes />
    </>
  );
};

export default Customers;
